//@flow

import type {Action} from '../actions/actions';
import * as actions from '../actions/actions';
import type {NavState} from '../store';


const defaultNav: NavState = {
  activeElementId: '',
  visibleElements: [],
  hiddenElements: [],
};

let initialNav = defaultNav;

/**
 * These actions affect the "watch", "schedule", and "about" components of the subnav bar.
 * Other generic navigation state is handled here also.
 *
 * @param state
 * @param action
 * @returns {*}
 */
export default function nav(state: NavState = initialNav, action: Action): NavState {

  switch (action.type) {

    case actions.CHANGE_SUBNAV: {
      let visible = state.visibleElements.slice();
      visible.push(action.payload);
      return Object.assign(
        {},
        state, {
          activeElementId: action.payload,
          visibleElements: visible,
        }
      );
    }

    case actions.CHANGE_SUBNAV_MORE:
      return Object.assign(
        {},
        state,
        {
          hiddenElements: state.visibleElements.slice(),
          visibleElements: [],
          activeElementId: action.payload,
        }
      );

    default:
      return state;
  }

};
